import React, { useEffect, useRef, useState } from "react";

import { trackEvent } from "../analytics";
import { trackAmplitudeEvent } from "../amplitude";

import DailyReminderModal from "./DailyReminderModal";
import Icon from "./Icon";
import Modal from "./Modal";
import ProSubscribeModal from "./ProSubscribeModal";
import Strike from "./Strike";

const DailyReminder = ({ selected, updateUrl, timeZone }) => {
  const [dailyReminderEmail, setDailyReminderEmail] = useState(selected);
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);

  let dailyReminder = null;
  if(dailyReminderEmail) {
    dailyReminder = (
      <p>
        Your daily reminder email is set for {dailyReminderEmail} {timeZone}.
      </p>
    );
  }

  return <>
    {dailyReminder}

    <button
      className={`btn btn-default btn-block ${dailyReminderEmail ? "" : "btn-lg"} joystix`}
      onClick={() => setShowModal(true)}
      style={{textWrap: "wrap"}}
    >
      <Icon name="bell" /> {
        dailyReminderEmail ?
          <>Update<span className="hidden-xs"> Daily Reminder</span></> :
          <>Set <span className="hidden-xs">a </span>Daily Reminder</>
      }
    </button>

    {
      showModal &&
        <DailyReminderModal
          dailyReminderEmail={dailyReminderEmail}
          onHidden={() => setShowModal(false)}
          onUpdate={(selected) => {
            setDailyReminderEmail(selected);
            modalRef.current.hide();
            setShowModal(false);
          }}
          ref={modalRef}
          updateUrl={updateUrl}
        />
    }
  </>;
};

const V5MaxPlayedTodayModal = ({ amplitudeRoundProperties, dailyReminder, languagePairingWebUrl, sentenceLimit }) => {
  useEffect(() => {
    trackEvent("max played today modal shown", { dailyReminder: !!dailyReminder });
    trackAmplitudeEvent("web_app_hit_daily_sentence_limit_modal", Object.assign(
      {},
      amplitudeRoundProperties || {},
      {
        sentence_limit: sentenceLimit,
        has_daily_reminder: !!dailyReminder?.selected,
        modal_version: "v5"
      }
    ));
  }, []);

  return (
    <Modal
      footer={
        <div className="text-left">
          <a className="btn btn-default btn-sm joystix" href={languagePairingWebUrl || "/dashboard"}><Icon name="chevron-left" />Dashboard</a>
        </div>
      }
      noClose={true}
      title="Daily Limit Reached"
    >
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
          <span className="text-secondary">{sentenceLimit} / {sentenceLimit} free sentences today</span>
          <span className="joystix" style={{ fontSize: "0.85em" }}>0 left</span>
        </div>
        <div className="progress" style={{ height: 10, marginBottom: 0 }}>
          <div
            className="progress-bar progress-bar-warning"
            role="progressbar"
            style={{ width: "100%" }}
          />
        </div>
      </div>

      <div style={{ fontSize: "1.1em", marginBottom: 20, textAlign: "center" }}>
        <p style={{ marginBottom: 8 }}>
          You've played all <strong>{sentenceLimit}</strong> free sentences for today! 🙌
        </p>
        <p style={{ marginBottom: 0 }}>
          Upgrade to Pro for <strong>unlimited daily sentences</strong> and much more. 🚀
        </p>
      </div>

      <ProSubscribeModal
        paddleConfigUrl="/api/v1/users/paddle_config"
        buttonClass="btn btn-success btn-block btn-lg joystix"
        buttonText="Go Pro - Keep Playing!"
        showBenefits={true}
        onSubscribed={({ isPro }) => {
          if (isPro) window.location.reload();
        }}
      />

      <p className="text-center text-secondary" style={{ marginTop: 12, marginBottom: 0 }}>
        Or come back tomorrow for {sentenceLimit} more free sentences.
      </p>

      {
        dailyReminder?.show && (
          <>
            <Strike style={{ fontSize: "1.3em", marginBottom: 10, marginTop: 10 }}>or</Strike>
            <DailyReminder {...dailyReminder} />
          </>
        )
      }
    </Modal>
  );
};

export default V5MaxPlayedTodayModal;
